import { ApiError } from '@kit/sync/http/api-error';
import { NetworkError } from '@kit/sync/http/network-error';
import { type FormEvent, useState } from 'react';
import { useNavigate } from 'react-router';
import { signIn } from '@/entities/session/api/sign-in';
import { msg } from '@/shared/i18n/msg';

/** An English key (translated where it is shown), or the server's message as is. */
function messageFor(error: unknown): string {
  if (error instanceof NetworkError) {
    return msg('Cannot reach the server. Signing in for the first time needs a connection.');
  }
  if (error instanceof ApiError && error.code === 'auth.invalid_credentials')
    return msg('Wrong email, username or password.');
  return error instanceof Error ? error.message : String(error);
}

export function useLoginForm(initialLogin: string) {
  const navigate = useNavigate();
  const [login, setLogin] = useState(initialLogin);
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      await signIn(login, password);
      navigate('/', { replace: true });
    } catch (caught) {
      setError(messageFor(caught));
    } finally {
      setBusy(false);
    }
  }

  return { login, setLogin, password, setPassword, error, busy, submit };
}
